// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Receipt-space1-lTnBT {
	margin-bottom: 6px !important;
}

.Receipt-space2-ueQsm {
	margin-bottom: 12px !important;
}

.Receipt-space3-KzxiU {
	margin-bottom: 18px !important;
}

.Receipt-space4-g1LLd {
	margin-bottom: 24px !important;
}

.Receipt-space5-JXTSe {
	margin-bottom: 30px !important;
}

.Receipt-space6-P2EsS {
	margin-bottom: 36px !important;
}

.Receipt-space7-UXljz {
	margin-bottom: 42px !important;
}

.Receipt-spaceTop8-agnk_ {
	margin-bottom: 48px !important;
}

.Receipt-spaceTop1-l4FLI {
	margin-top: 6px !important;
}

.Receipt-spaceTop2-ksMHE {
	margin-top: 12px !important;
}

.Receipt-spaceTop3-ZWR7b {
	margin-top: 18px !important;
}

.Receipt-spaceTop4-rC9Wk {
	margin-top: 24px !important;
}

.Receipt-spaceTop5-o5QPp {
	margin-top: 30px !important;
}

.Receipt-spaceTop6-pQLaV {
	margin-top: 36px !important;
}

.Receipt-spaceTop7-B6AJP {
	margin-top: 42px !important;
}

.Receipt-spaceTop8-agnk_ {
	margin-top: 48px !important;
}

.Receipt-noMargin-c64S1 {
	margin: 0px !important;
}

.Receipt-padding1-bMCqt {
	padding-bottom: 6px !important;
}

.Receipt-padding2-LwJZW {
	padding-bottom: 12px !important;
}

.Receipt-padding3-tkKtC {
	padding-bottom: 18px !important;
}

.Receipt-padding4-RK89a {
	padding-bottom: 24px !important;
}

.Receipt-padding5-d1fEE {
	padding-bottom: 30px !important;
}

.Receipt-padding6-aFgzh {
	padding-bottom: 36px !important;
}

.Receipt-padding7-RJs4_ {
	padding-bottom: 42px !important;
}

.Receipt-paddingTop1-MY0og {
	padding-top: 6px !important;
}

.Receipt-paddingTop2-ZR2Km {
	padding-top: 12px !important;
}

.Receipt-paddingTop3-_6Y5A {
	padding-top: 18px !important;
}

.Receipt-paddingTop4-vAB3h {
	padding-top: 24px !important;
}

.Receipt-paddingTop5-kBIdE {
	padding-top: 30px !important;
}

.Receipt-paddingTop6-FjFXz {
	padding-top: 36px !important;
}

.Receipt-paddingTop7-g7cYe {
	padding-top: 42px !important;
}

.Receipt-noPadding-kCEoU {
	padding: 0px !important;
}

.Receipt-textBold-EiWB_ {
	font-weight: 500 !important;
}

.Receipt-textBolder-F4zSD {
	font-weight: 700 !important;
}

.Receipt-textNormal-KqGyX {
	font-weight: normal !important;
}

.Receipt-spaceBottom20-kTfSo {
	margin-bottom: 20px;
}

.Receipt-spaceBottom10-fnisi {
	margin-bottom: 10px;
}

.Receipt-marginNone-HbGkH {
	margin: 0;
}

.Receipt-spaceBottom15-K5a61 {
	margin-bottom: 15px;
}

.Receipt-marginTopNone-hZfow {
	margin-top: 0;
}

.Receipt-spaceTop11-cyeBT {
	margin-top: 11px;
}

.Receipt-spaceTop21-HuX_V {
	margin-top: 21px;
}

.Receipt-spaceTop20-flV3B {
	margin-top: 20px;
}

.Receipt-spaceTop10-xwplA {
	margin-top: 10px;
}

/*New Design Text Colors */

.Receipt-textDarkBlue-vKcr4 {
	color: rgb(20, 39, 94) !important;
}

.Receipt-textLightBlue-zsMDT {
	color: rgb(57, 87, 106) !important;
}

.Receipt-textLightSandleGreen-YDA63 {
	color: rgb(76, 86, 41) !important;
}

.Receipt-textLightBrown-YO9KS {
	color: rgb(115, 79, 33) !important;
}

.Receipt-textMediumMaroon-gWpY0 {
	color: rgb(87, 37, 51) !important;
}

.Receipt-textBrown-UCfQO {
	color: rgb(160, 47, 24) !important;
}

.Receipt-textMaroon-z5mWW {
	color: rgb(155, 49, 67) !important;
}

.Receipt-textDarkBrown-KFGys {
	color: rgb(83, 18, 16) !important;
}

.Receipt-textMediumBrown-cGjVB {
	color: rgb(142, 28, 10) !important;
}

.Receipt-textSkyBlue-u4c9Y {
	color: rgb(37, 117, 141) !important;
}

.Receipt-textGray-wldoi {
	color: rgb(77, 65, 51) !important;
}

.Receipt-Container-sT6J8 {
	min-height: 700px;
	position: relative;
}

.Receipt-containerResponsive-qP2Xk {
	max-width: var(--max-container-width);
	margin: 40px auto 0 auto;
}

.Receipt-receiptPanel-aB_vY {
	border-radius: 0;
}

.Receipt-rowWidth-CWgBQ {
	width: 400px
}

.Receipt-textBold-EiWB_ {
	font-weight: bold;
}

.Receipt-rowTable-WWXpz {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	gap: 10px;
}

/** Common Styles  start**/

.Receipt-pullRight-bbY6G {
	float: right;
}

.Receipt-iconSection-IagOY {
	position: relative;
	top: -2px;
}

.Receipt-iconSection-IagOY svg {
	margin: -4px 0 0 0;
}

.Receipt-positionR-pket_ {
	position: relative;
}

.Receipt-faqImage-iGuq8 {
	width: 20px;
	vertical-align: middle;
	margin-right: 5px;
}

.Receipt-titleText-N7_n0 {
	font-size: 26px;
	font-weight: bold;
	margin: 0 0 4px -3px;
}

.Receipt-button-OK9t8 {
	background-color: var(--primary-bg);
	color: var(--primary-btn-foreground) !important;
	border-radius: 4px;
	padding: 11px 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 4px;
	text-decoration: none !important;
	cursor: pointer;
}

.Receipt-grid-UNWvZ {
	display: grid;
	grid-template-columns: 56% 40%;
	grid-gap: 40px;
}

.Receipt-innnerTitleText-WqXJD {
	font-size: 20px;
	font-weight: bold;
	margin: 0;
}

.Receipt-createDateCss-y4Ej3 {
	font-size: 16px;
	margin-top: 11px;
}

.Receipt-leftPanel-UMqSX {
	border-radius: 8px;
	border: 1px solid var(--primary-border);
	padding: 30px;
}

.Receipt-borderLine-tqtcV {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.Receipt-dateGrid-m1_yt {
	display: grid;
	grid-template-columns: 36% 23% 37%;
}

.Receipt-text-S_NZ4 {
	font-size: 16px;
	font-weight: 600;
}

.Receipt-subText-xT8hs {
	font-size: 16px;
	margin-top: 10px;
}

.Receipt-dateText-3c17Z {
	margin-top: 3px;
}

.Receipt-accommoGrid-Ib6Ub {
	display: grid;
	grid-template-columns: 60% 40%;
}

.Receipt-gridBottom-mAQ8t {
	margin-bottom: 30px;
}

.Receipt-titleColor-zOjCI {
	margin-top: 15px;
	font-size: 16px;
	color: var(--primary-link-foreground);
}

.Receipt-tableFlex-oVFMk {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	font-size: 16px;
	margin-top: 23px;
	gap: 15px;
	word-break: break-word;
}

.Receipt-totalBorderLine-iRt6F {
	border-top: 1px solid var(--primary-border);
	margin: 23px 0;
}

.Receipt-paymentWidth-mFYCW {
	width: 45%;
}

.Receipt-paymentTop-SVNoV {
	margin-top: 36px;
}

.Receipt-receiptFooter-qR9R9 {
	font-size: 16px;
	margin: 26px 0 100px;
}

.Receipt-minusFlex-Snblz {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

@media screen and (max-width: 767px) {
	.Receipt-grid-UNWvZ {
		grid-template-columns: 100%;
	}

	.Receipt-button-OK9t8 {
		padding: 11px 18px 8px;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		    -ms-flex-align: center;
		        align-items: center;
		-webkit-box-pack: center;
		    -ms-flex-pack: center;
		        justify-content: center;
	}

	.Receipt-dateGrid-m1_yt {
		display: grid;
		grid-template-columns: 36% 23% 37%;
		word-break: break-word;
		grid-gap: 7px;
	}
}

.Receipt-displayFlex-vqtz5 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}

.Receipt-displayTableCell-cxl3V {
	display: table-cell;
	vertical-align: top;
}

.Receipt-displayTableCellMiddle-dF7Kk {
	vertical-align: middle;
}

@media screen and (min-width:1200px) {
	.Receipt-printBtn-qmp6C {
		margin-right: 11px;
	}
}

/** Common Styles  start**/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/Receipt/Receipt.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,qCAAqC;CACrC,wBAAwB;AACzB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,mBAAe;KAAf,eAAe;CACf,SAAS;AACV;;AAEA,0BAA0B;;AAC1B;CACC,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAGA;CACC,WAAW;CACX,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;CACC,mCAAmC;CACnC,+CAA+C;CAC/C,kBAAkB;CAClB,kBAAkB;CAClB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,gCAAgC;CAChC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,cAAc;AACf;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,uCAAuC;CACvC,aAAa;AACd;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,aAAa;CACb,kCAAkC;AACnC;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,qCAAqC;AACtC;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,eAAe;CACf,gBAAgB;CAChB,SAAS;CACT,sBAAsB;AACvB;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,oBAAoB;AACrB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sBAAsB;EACtB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;CACxB;;CAEA;EACC,aAAa;EACb,kCAAkC;EAClC,sBAAsB;EACtB,aAAa;CACd;AACD;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;AACd;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC;EACC,kBAAkB;CACnB;AACD;;AAEA,0BAA0B","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/helpers.css';\n\n.Container {\n\tmin-height: 700px;\n\tposition: relative;\n}\n\n.containerResponsive {\n\tmax-width: var(--max-container-width);\n\tmargin: 40px auto 0 auto;\n}\n\n.receiptPanel {\n\tborder-radius: 0;\n}\n\n.rowWidth {\n\twidth: 400px\n}\n\n.textBold {\n\tfont-weight: bold;\n}\n\n.rowTable {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tflex-wrap: wrap;\n\tgap: 10px;\n}\n\n/** Common Styles  start**/\n.pullRight {\n\tfloat: right;\n}\n\n.iconSection {\n\tposition: relative;\n\ttop: -2px;\n}\n\n.iconSection svg {\n\tmargin: -4px 0 0 0;\n}\n\n.positionR {\n\tposition: relative;\n}\n\n\n.faqImage {\n\twidth: 20px;\n\tvertical-align: middle;\n\tmargin-right: 5px;\n}\n\n.titleText {\n\tfont-size: 26px;\n\tfont-weight: bold;\n\tmargin: 0 0 4px -3px;\n}\n\n.button {\n\tbackground-color: var(--primary-bg);\n\tcolor: var(--primary-btn-foreground) !important;\n\tborder-radius: 4px;\n\tpadding: 11px 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 4px;\n\ttext-decoration: none !important;\n\tcursor: pointer;\n}\n\n.grid {\n\tdisplay: grid;\n\tgrid-template-columns: 56% 40%;\n\tgrid-gap: 40px;\n}\n\n.innnerTitleText {\n\tfont-size: 20px;\n\tfont-weight: bold;\n\tmargin: 0;\n}\n\n.createDateCss {\n\tfont-size: 16px;\n\tmargin-top: 11px;\n}\n\n.leftPanel {\n\tborder-radius: 8px;\n\tborder: 1px solid var(--primary-border);\n\tpadding: 30px;\n}\n\n.borderLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.dateGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 36% 23% 37%;\n}\n\n.text {\n\tfont-size: 16px;\n\tfont-weight: 600;\n}\n\n.subText {\n\tfont-size: 16px;\n\tmargin-top: 10px;\n}\n\n.dateText {\n\tmargin-top: 3px;\n}\n\n.accommoGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 60% 40%;\n}\n\n.gridBottom {\n\tmargin-bottom: 30px;\n}\n\n.titleColor {\n\tmargin-top: 15px;\n\tfont-size: 16px;\n\tcolor: var(--primary-link-foreground);\n}\n\n.tableFlex {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tfont-size: 16px;\n\tmargin-top: 23px;\n\tgap: 15px;\n\tword-break: break-word;\n}\n\n.totalBorderLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 23px 0;\n}\n\n.paymentWidth {\n\twidth: 45%;\n}\n\n.paymentTop {\n\tmargin-top: 36px;\n}\n\n.receiptFooter {\n\tfont-size: 16px;\n\tmargin: 26px 0 100px;\n}\n\n.minusFlex {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n@media screen and (max-width: 767px) {\n\t.grid {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.button {\n\t\tpadding: 11px 18px 8px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n\n\t.dateGrid {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 36% 23% 37%;\n\t\tword-break: break-word;\n\t\tgrid-gap: 7px;\n\t}\n}\n\n.displayFlex {\n\tdisplay: flex;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\tvertical-align: top;\n}\n\n.displayTableCellMiddle {\n\tvertical-align: middle;\n}\n\n@media screen and (min-width:1200px) {\n\t.printBtn {\n\t\tmargin-right: 11px;\n\t}\n}\n\n/** Common Styles  start**/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Receipt-space1-lTnBT`,
	"space2": `Receipt-space2-ueQsm`,
	"space3": `Receipt-space3-KzxiU`,
	"space4": `Receipt-space4-g1LLd`,
	"space5": `Receipt-space5-JXTSe`,
	"space6": `Receipt-space6-P2EsS`,
	"space7": `Receipt-space7-UXljz`,
	"spaceTop8": `Receipt-spaceTop8-agnk_`,
	"spaceTop1": `Receipt-spaceTop1-l4FLI`,
	"spaceTop2": `Receipt-spaceTop2-ksMHE`,
	"spaceTop3": `Receipt-spaceTop3-ZWR7b`,
	"spaceTop4": `Receipt-spaceTop4-rC9Wk`,
	"spaceTop5": `Receipt-spaceTop5-o5QPp`,
	"spaceTop6": `Receipt-spaceTop6-pQLaV`,
	"spaceTop7": `Receipt-spaceTop7-B6AJP`,
	"noMargin": `Receipt-noMargin-c64S1`,
	"padding1": `Receipt-padding1-bMCqt`,
	"padding2": `Receipt-padding2-LwJZW`,
	"padding3": `Receipt-padding3-tkKtC`,
	"padding4": `Receipt-padding4-RK89a`,
	"padding5": `Receipt-padding5-d1fEE`,
	"padding6": `Receipt-padding6-aFgzh`,
	"padding7": `Receipt-padding7-RJs4_`,
	"paddingTop1": `Receipt-paddingTop1-MY0og`,
	"paddingTop2": `Receipt-paddingTop2-ZR2Km`,
	"paddingTop3": `Receipt-paddingTop3-_6Y5A`,
	"paddingTop4": `Receipt-paddingTop4-vAB3h`,
	"paddingTop5": `Receipt-paddingTop5-kBIdE`,
	"paddingTop6": `Receipt-paddingTop6-FjFXz`,
	"paddingTop7": `Receipt-paddingTop7-g7cYe`,
	"noPadding": `Receipt-noPadding-kCEoU`,
	"textBold": `Receipt-textBold-EiWB_`,
	"textBolder": `Receipt-textBolder-F4zSD`,
	"textNormal": `Receipt-textNormal-KqGyX`,
	"spaceBottom20": `Receipt-spaceBottom20-kTfSo`,
	"spaceBottom10": `Receipt-spaceBottom10-fnisi`,
	"marginNone": `Receipt-marginNone-HbGkH`,
	"spaceBottom15": `Receipt-spaceBottom15-K5a61`,
	"marginTopNone": `Receipt-marginTopNone-hZfow`,
	"spaceTop11": `Receipt-spaceTop11-cyeBT`,
	"spaceTop21": `Receipt-spaceTop21-HuX_V`,
	"spaceTop20": `Receipt-spaceTop20-flV3B`,
	"spaceTop10": `Receipt-spaceTop10-xwplA`,
	"textDarkBlue": `Receipt-textDarkBlue-vKcr4`,
	"textLightBlue": `Receipt-textLightBlue-zsMDT`,
	"textLightSandleGreen": `Receipt-textLightSandleGreen-YDA63`,
	"textLightBrown": `Receipt-textLightBrown-YO9KS`,
	"textMediumMaroon": `Receipt-textMediumMaroon-gWpY0`,
	"textBrown": `Receipt-textBrown-UCfQO`,
	"textMaroon": `Receipt-textMaroon-z5mWW`,
	"textDarkBrown": `Receipt-textDarkBrown-KFGys`,
	"textMediumBrown": `Receipt-textMediumBrown-cGjVB`,
	"textSkyBlue": `Receipt-textSkyBlue-u4c9Y`,
	"textGray": `Receipt-textGray-wldoi`,
	"Container": `Receipt-Container-sT6J8`,
	"containerResponsive": `Receipt-containerResponsive-qP2Xk`,
	"receiptPanel": `Receipt-receiptPanel-aB_vY`,
	"rowWidth": `Receipt-rowWidth-CWgBQ`,
	"rowTable": `Receipt-rowTable-WWXpz`,
	"pullRight": `Receipt-pullRight-bbY6G`,
	"iconSection": `Receipt-iconSection-IagOY`,
	"positionR": `Receipt-positionR-pket_`,
	"faqImage": `Receipt-faqImage-iGuq8`,
	"titleText": `Receipt-titleText-N7_n0`,
	"button": `Receipt-button-OK9t8`,
	"grid": `Receipt-grid-UNWvZ`,
	"innnerTitleText": `Receipt-innnerTitleText-WqXJD`,
	"createDateCss": `Receipt-createDateCss-y4Ej3`,
	"leftPanel": `Receipt-leftPanel-UMqSX`,
	"borderLine": `Receipt-borderLine-tqtcV`,
	"dateGrid": `Receipt-dateGrid-m1_yt`,
	"text": `Receipt-text-S_NZ4`,
	"subText": `Receipt-subText-xT8hs`,
	"dateText": `Receipt-dateText-3c17Z`,
	"accommoGrid": `Receipt-accommoGrid-Ib6Ub`,
	"gridBottom": `Receipt-gridBottom-mAQ8t`,
	"titleColor": `Receipt-titleColor-zOjCI`,
	"tableFlex": `Receipt-tableFlex-oVFMk`,
	"totalBorderLine": `Receipt-totalBorderLine-iRt6F`,
	"paymentWidth": `Receipt-paymentWidth-mFYCW`,
	"paymentTop": `Receipt-paymentTop-SVNoV`,
	"receiptFooter": `Receipt-receiptFooter-qR9R9`,
	"minusFlex": `Receipt-minusFlex-Snblz`,
	"displayFlex": `Receipt-displayFlex-vqtz5`,
	"displayTableCell": `Receipt-displayTableCell-cxl3V`,
	"displayTableCellMiddle": `Receipt-displayTableCellMiddle-dF7Kk`,
	"printBtn": `Receipt-printBtn-qmp6C`
};
module.exports = ___CSS_LOADER_EXPORT___;
